import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.structured-clone.js";
import "core-js/modules/es.array.map.js";
import moment from "moment";
import { getData } from "@/services/axios";
import { mapState } from "vuex";
import RowItem from "../RowItem";
import MonthlyComment from "./MonthlyComment";
import LoadingMessage from "@/components/common/LoadingMessage";
import CalendarHeading from "./monthly/CalendarHeading";
import GroupClassSelectForm from "./monthly/GroupClassSelectForm";
import monthlyMixin from "./monthlyMixin";
import { assignAbsentBudge } from "@/services/common";
var __default__ = {
  name: "Summary",
  components: {
    MonthlyComment: MonthlyComment,
    RowItem: RowItem,
    LoadingMessage: LoadingMessage,
    CalendarHeading: CalendarHeading,
    GroupClassSelectForm: GroupClassSelectForm
  },
  mixins: [monthlyMixin],
  data: function data() {
    return {
      schoolOffDaysOfYear: {},
      classSchoolOffDaysOfYear: {},
      classMonthData: {},
      students: {},
      attendanceMonthlyComments: [],
      isLoading: true,
      showModal: false,
      selectedStudent: {},
      visibleClassroom: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(["grades", "studentAddress", "holidays"])), {}, {
    localYearMonth: function localYearMonth() {
      return moment(this.filter.yearMonth).format("YYYY年MM月");
    },
    currentClassName: function currentClassName() {
      var _this = this;

      var classroom = this.classrooms.find(function (v) {
        return v.id === parseInt(_this.filter.classroomId);
      });
      return classroom.name;
    }
  }),
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.filter.yearMonth = this.$route.query.year_month ? this.$route.query.year_month : moment().format("YYYY-MM");
      this.filter.classroomId = this.$route.query.classroom_id ? this.$route.query.classroom_id : 0;
      this.filter.groupId = this.$route.query.group_id ? this.$route.query.group_id : 0; // 1年間の日数を取得し、休日をチェックする

      var fiscalDate = moment(this.filter.yearMonth).add(-3, "month").month(3).startOf("month");
      var fiscalYearDaysLength = fiscalDate.clone().add(1, "years").diff(fiscalDate, "day");
      var schoolOffDaysOfYear = {};

      for (var i = 1; i <= fiscalYearDaysLength; i++) {
        var date = fiscalDate.format("YYYY-MM-DD");

        if (fiscalDate.format("d") === "0" || fiscalDate.format("d") === "6" || this.holidays.includes(date)) {
          schoolOffDaysOfYear[date] = true;
        } else {
          schoolOffDaysOfYear[date] = false;
        }

        fiscalDate.add(1, "day");
      }

      this.schoolOffDaysOfYear = schoolOffDaysOfYear;
      this.setData();
    },
    // クラスを変更した時はinitを経由せずに必要な部分だけ初期化
    handleClassroomChange: function handleClassroomChange(classroomId) {
      this.filter.classroomId = classroomId;
      this.setData();
    },
    // グループを変更した時もinitを経由せずに必要な部分だけ初期化
    handleGroupChange: function handleGroupChange(groupId) {
      this.filter.groupId = groupId;
      this.filter.classroomId = 0;
      this.setData();
    },
    setData: function setData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var date, currentMonth, startOfMonth, endOfMonth, fiscalYear, data, selectClassStudentAttendaceObject, classroom, events, absentList3, absentList20, absentList30;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.isLoading = true;
                date = moment(_this2.filter.yearMonth);
                currentMonth = date.month();
                startOfMonth = date.clone().startOf("month");
                endOfMonth = date.clone().endOf("month");
                fiscalYear = date.clone().add(-3, "month").year();
                _context.next = 8;
                return getData(["reader/get_continuously_absent-students", "reader/get_frequently_absent-students", "reader/get_students_with_attendance?fiscal_year=".concat(fiscalYear, "&classroom_id=").concat(_this2.filter.classroomId, "&group_id=").concat(_this2.filter.groupId), "events?orderby=updated_at&order=asc&classroom_id=" + _this2.filter.classroomId + "&fiscal_year=" + fiscalYear, "attendance_monthly_comments?classroom_id=" + _this2.filter.classroomId + "&start_of_month=" + startOfMonth.format("YYYY-MM-DD")]).catch(function (error) {
                  console.log(error);
                });

              case 8:
                data = _context.sent;
                // 表示するクラスを整理する
                selectClassStudentAttendaceObject = data[2].items;
                _this2.visibleClassroom = [];
                _this2.classMonthData = {};

                if (_this2.filter.classroomId === 0) {
                  // 全てのクラスを選択したとき
                  _this2.classrooms.forEach(function (v) {
                    if (selectClassStudentAttendaceObject[v.id]) {
                      _this2.visibleClassroom.push(v);

                      _this2.classMonthData[v.id] = structuredClone(_this2.monthData);
                      _this2.classSchoolOffDaysOfYear[v.id] = structuredClone(_this2.schoolOffDaysOfYear);
                    }
                  });
                } else {
                  // 個別のクラスを選択したとき
                  classroom = _this2.classrooms.find(function (v) {
                    return v.id === parseInt(_this2.filter.classroomId);
                  });

                  if (classroom) {
                    _this2.visibleClassroom.push(classroom);

                    _this2.classMonthData[classroom.id] = structuredClone(_this2.monthData);
                    _this2.classSchoolOffDaysOfYear[classroom.id] = structuredClone(_this2.schoolOffDaysOfYear);
                  }
                }

                events = data[3].items;
                events.forEach(function (v) {
                  var from = moment(v.from);
                  var to = moment(v.to);

                  while (from.isSameOrBefore(to, "day")) {
                    v.classroom.forEach(function (w) {
                      if (_this2.classSchoolOffDaysOfYear[w.classroom_id]) {
                        _this2.classSchoolOffDaysOfYear[w.classroom_id][from.format("YYYY-MM-DD")] = Boolean(v.is_school_day_off);

                        if (from.month() === currentMonth && _this2.classMonthData[w.classroom_id]) {
                          _this2.classMonthData[w.classroom_id][from.date() - 1].isSchoolDayOff = Boolean(v.is_school_day_off);
                        }
                      }
                    });
                    from.add(1, "day");
                  }
                }); // 長期欠席者

                absentList3 = data[0].items;
                absentList20 = data[1].items[0];
                absentList30 = data[1].items[1]; // 生徒ごとの欠席状況

                _this2.students = {};
                Object.keys(selectClassStudentAttendaceObject).forEach(function (classroomId) {
                  var classStudentList = selectClassStudentAttendaceObject[classroomId].map(function (student) {
                    var monthlySummary = _objectSpread({}, _this2.monthlyYearlySummaryTemplate); // mixin


                    monthlySummary["要出席日数"] = _this2.schoolDayLength(classroomId);
                    monthlySummary["出席日数"] = _this2.schoolDayBeforeYearMonthLength(classroomId);

                    var yearlySummary = _objectSpread({}, _this2.monthlyYearlySummaryTemplate); // mixin


                    yearlySummary["要出席日数"] = _this2.schoolDaysOfYearLength(classroomId);
                    yearlySummary["出席日数"] = _this2.schoolDaysOfYearBeforeTodayLength(classroomId);
                    var monthlyTypeSummary = {};
                    student.attendance.forEach(function (v) {
                      if (_this2.classSchoolOffDaysOfYear[classroomId][v.date]) {
                        return; // 休日のデータは無視する
                      }

                      if (!v.counting_type) {
                        return; // countingTypeがないときはSummaryに含めない
                      }

                      var countingType = v.counting_type.counting_type;

                      if (moment(v.date).isSameOrBefore(endOfMonth)) {
                        // mixin
                        // year
                        _this2.aggregateStudentSummary(yearlySummary, countingType);

                        if (moment(v.date).isBetween(startOfMonth, endOfMonth, null, "[]")) {
                          // mixin
                          // month
                          _this2.aggregateStudentSummary(monthlySummary, countingType);

                          _this2.aggregateMonthlyTypeSummary(v, monthlyTypeSummary);
                        }
                      }
                    });
                    return Object.assign(student, {
                      specialAbsents: assignAbsentBudge(student, absentList3, absentList20, absentList30),
                      monthlySummary: monthlySummary,
                      monthlyTypeSummary: monthlyTypeSummary,
                      yearlySummary: yearlySummary
                    });
                  });
                  _this2.students[classroomId] = classStudentList;
                }); // 今月のコメント

                _this2.attendanceMonthlyComments = data[4].items;
                _this2.isLoading = false;

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    myAttendanceMonthlyComment: function myAttendanceMonthlyComment(studentId) {
      var comment = this.attendanceMonthlyComments.find(function (v) {
        return v.student_id === studentId;
      });

      if (comment) {
        return comment.comment;
      }
    },
    handleCommentEdit: function handleCommentEdit(v) {
      this.showModal = true;
      this.selectedStudent = v;
    },
    getAttendanceMonthlyComments: function getAttendanceMonthlyComments() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getData("attendance_monthly_comments?classroom_id=" + _this3.filter.classroomId + "&start_of_month=" + moment(_this3.filter.yearMonth).startOf("month").format("YYYY-MM-DD")).catch(function (error) {
                  console.log(error);
                });

              case 2:
                data = _context2.sent;
                _this3.attendanceMonthlyComments = data.items;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    closeModal: function closeModal() {
      // コメント部分だけ更新する
      this.getAttendanceMonthlyComments();
      this.showModal = false;
    },
    schoolDayLength: function schoolDayLength(classroomId) {
      return this.classMonthData[classroomId].filter(function (v) {
        return !v.isSchoolDayOff;
      }).length;
    },
    schoolDayBeforeYearMonthLength: function schoolDayBeforeYearMonthLength(classroomId) {
      var yearMonth = moment(this.filter.yearMonth).add(1, "month").startOf("month");
      var today = moment();

      if (today.isBefore(yearMonth)) {
        return this.classMonthData[classroomId].filter(function (v) {
          return !v.isSchoolDayOff && today.isAfter(v["YYYY-MM-DD"]);
        }).length;
      } else {
        return this.classMonthData[classroomId].filter(function (v) {
          return !v.isSchoolDayOff && yearMonth.isAfter(v["YYYY-MM-DD"]);
        }).length;
      }
    },
    schoolDaysOfYearLength: function schoolDaysOfYearLength(classroomId) {
      var _this4 = this;

      var yearMonth = moment(this.filter.yearMonth).add(1, "month").startOf("month");
      return Object.keys(this.classSchoolOffDaysOfYear[classroomId]).filter(function (k) {
        return !_this4.classSchoolOffDaysOfYear[classroomId][k] && yearMonth.isAfter(moment(k));
      }).length;
    },
    schoolDaysOfYearBeforeTodayLength: function schoolDaysOfYearBeforeTodayLength(classroomId) {
      var _this5 = this;

      var yearMonth = moment(this.filter.yearMonth).add(1, "month").startOf("month");
      var today = moment();

      if (today.isBefore(yearMonth)) {
        return Object.keys(this.classSchoolOffDaysOfYear[classroomId]).filter(function (k) {
          return !_this5.classSchoolOffDaysOfYear[classroomId][k] && today.isAfter(moment(k));
        }).length;
      } else {
        return Object.keys(this.classSchoolOffDaysOfYear[classroomId]).filter(function (k) {
          return !_this5.classSchoolOffDaysOfYear[classroomId][k] && yearMonth.isAfter(moment(k));
        }).length;
      }
    }
  }
};
import { ref } from "vue";
import { useMonthData } from "@/composables/monthData";
import { storeToRefs } from "pinia";
import { useGradeClassroomStore } from "@/stores/gradeClassroom";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;

    var _storeToRefs = storeToRefs(useGradeClassroomStore()),
        classrooms = _storeToRefs.classrooms;

    var filter = ref({
      classroomId: 0,
      groupId: 0,
      yearMonth: null
    });

    var _useMonthData = useMonthData(filter.value),
        monthData = _useMonthData.monthData,
        days = _useMonthData.days;

    expose({
      classrooms: classrooms,
      filter: filter,
      monthData: monthData,
      days: days
    });
    return {
      __sfc: true,
      classrooms: classrooms,
      filter: filter,
      monthData: monthData,
      days: days,
      RowItem: RowItem,
      MonthlyComment: MonthlyComment,
      LoadingMessage: LoadingMessage,
      CalendarHeading: CalendarHeading,
      GroupClassSelectForm: GroupClassSelectForm
    };
  }
});